
<template>
	<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
		<div class="container-fluid">
			<a href="/" class="navbar-brand mr-0 mr-md-2 logo">
				<span class="logo-lg">
					<img src="@assets/Logomark2000.png" alt height="45" />
					<span class="d-inline h5 ml-2 text-logo">JINZ.AI</span>
				</span>
				<span class="logo-sm">
					<img src="@assets/Logomark2000.png" alt height="45" />
				</span>
			</a>
			<div v-if="use_language" class="row">
				<div class="language">
					{{selected_language == 'us' ? 'English(US)' : '日本語'}}
				</div>

				<a id="languange" class="language" @click="changeLang(selected_language)" href="#">
					{{selected_language == 'us' ? '日本語' : 'English(US)'}}
				</a>
				<b-tooltip target="languange" placement="bottom">{{selected_language == 'us' ? 'Japanese' : 'English(US)'}}</b-tooltip>

			</div>
			
			<div class="media" v-if="company.name">
				<img :src="company.avatar_path" 
					class="avatar-md rounded-rounder mr-3" />
				<span class="d-inline h6 m-auto text-logo">
					{{company.name}}
				</span>
			</div>
			
		</div>
	</div>

</template>

<script>
	export default {
		data(){
			return {
				model:{
					
				}
			}
		},
		props:{
			use_language:{
			default:false
				},
				selected_language: {
			default: 'us'
			},
			company:{
				default:{}
			},
		},
		methods:{
			changeLang(lang){
				this.$emit('changeLang', lang)
			}
		}
	}
</script>

<style lang="scss">
.noti-scroll {
	height: 220px;
}
.ps > .ps__scrollbar-y-rail {
	width: 8px !important;
	background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
	width: 6px !important;
}
.button-menu-mobile {
	outline: none !important;
}
.language {
	padding-left : 5px;
	padding-right : 5px;
}
</style>
